/**
 * Web3 infra 一些公共表现所使用的配置
 * 这里所有不可直接更改这个对象的值，只能读取属性
 * 例如：钱包表现：仅使用第三方钱包
 * 固定支持的钱包列表
 */

// import { isBrowser } from '../utils/trick';
import { EventBasedStore } from '../utils/EventBasedStore';
import { InitWalletHubCenterOptions } from '../wallet-hub/Web3WalletHubCenter';

export type Web3InfraGlobalConfig = {
  /**
   *
   * 仅支持第三方钱包， 默认false，是需要支持云钱包的
   *
   * @deprecated 后续会移除该属性，已经开始逐步下限网页内云钱包，后续会彻底移除
   * */
  onlyThirdParty: boolean;
  thirdWalletOpts: InitWalletHubCenterOptions;
  hasConfigured: boolean;
  modalDefaultIndex: number;
  autoUpdateBalance: boolean;
  appName: string;
  // 是否加载uniframe
  loadUniframe: boolean;
};

// 这期暂时不做，影响面太大，荷兰站下面所有业务都要适配没有云钱包的逻辑，后续计划在钱包连接组件里面适配该逻辑，荷兰站云钱包连接按钮置灰，并给与对应的文案提示
// const onlyThirdParty = (() => {
//   if (!isBrowser) {
//     return false;
//   }

//   const { hostname, pathname } = window.location;

//   // 线上荷兰站隐藏云钱包
//   if (hostname.endsWith('.nl') && pathname.includes('en-NL')) {
//     return true;
//   }

//   // 开发/测试环境荷兰站隐藏云钱包
//   if ((hostname.includes('local') || hostname.includes('sbu-test-5')) && pathname.includes('en-NL')) {
//     return true;
//   }

//   return false;
// })();
export const web3InfraGlobalConfigStore = new EventBasedStore<Web3InfraGlobalConfig>({
  onlyThirdParty: false,
  thirdWalletOpts: {},
  hasConfigured: false,
  modalDefaultIndex: 101,
  autoUpdateBalance: false,
  appName: '',
  loadUniframe: false,
});

export const getWeb3InfraGlobalConfig = () => {
  return web3InfraGlobalConfigStore.state;
};

export const useWeb3InfraGlobalConfig = web3InfraGlobalConfigStore.useStoreState.bind(web3InfraGlobalConfigStore);

export const getDefaultIndex = () => {
  return web3InfraGlobalConfigStore.state.modalDefaultIndex;
};
